import styled from 'styled-components'

export const Container = styled.div`
  margin: auto;
  max-width: 75%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const InfoText = styled.label`
  font-size: 16px;
  text-align: justify;
  color: #000000;
`

export const SubTitle = styled(InfoText)`
  font-weight: bold;
  text-align: center;
`

export const Image = styled.img`
  width: 110px;
  margin: 10px;
  justify-self: center;
  align-self: center;
`
